import '@/services/logbox';
import { useEffect } from 'react';
import { router, Stack } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import * as SplashScreen from 'expo-splash-screen';
import * as Notifications from 'expo-notifications';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { StyleSheet } from 'react-native';
import { Colors } from '@/constants/colors';
import { useLivePoller } from '@/hooks/useLivePoller';
import {
  addPushTokenRegistrationListener,
  setupRemotePushNotifications,
} from '@/services/notifications';
import { Sport } from '@/types';

SplashScreen.preventAutoHideAsync().catch(() => {});

function openNotificationMatch(notification: any) {
  const data = notification.request.content.data ?? {};
  const gameId = data.gameId;
  const sport = data.sport;
  if (typeof gameId !== 'string') return;
  if (sport !== 'futebol' && sport !== 'nba' && sport !== 'nfl') return;

  router.push(`/match/${encodeURIComponent(gameId)}?sport=${sport as Sport}` as any);
}

export default function RootLayout() {
  useLivePoller();

  useEffect(() => {
    let active = true;
    let pushTokenSubscription: { remove: () => void } | undefined;

    setupRemotePushNotifications()
      .then(() => {
        if (active) pushTokenSubscription = addPushTokenRegistrationListener();
      })
      .catch(() => {});
    SplashScreen.hideAsync().catch(() => {});

    const initialResponse = Notifications.getLastNotificationResponse();
    if (initialResponse?.notification) {
      setTimeout(() => openNotificationMatch(initialResponse.notification), 0);
    }

    const responseSubscription = Notifications.addNotificationResponseReceivedListener((response: any) => {
      openNotificationMatch(response.notification);
    });

    return () => {
      active = false;
      pushTokenSubscription?.remove();
      responseSubscription.remove();
    };
  }, []);

  return (
    <GestureHandlerRootView style={styles.root}>
      <StatusBar style="light" />
      <Stack screenOptions={{ headerShown: false, contentStyle: { backgroundColor: Colors.background } }}>
        <Stack.Screen name="(tabs)" />
        <Stack.Screen name="match/[id]" options={{ presentation: 'card', headerShown: false }} />
      </Stack>
    </GestureHandlerRootView>
  );
}

const styles = StyleSheet.create({ root: { flex: 1, backgroundColor: Colors.background } });
